import { shopifyConfig } from '@/config/shopify';

interface ShopifyFetchOptions {
  query: string;
  variables?: Record<string, unknown>;
}

interface ShopifyGraphQLError {
  message: string;
}

interface ShopifyGraphQLResponse<T> {
  data?: T;
  errors?: ShopifyGraphQLError[];
}

export async function shopifyFetch<T>(options: ShopifyFetchOptions): Promise<T> {
  const { query, variables } = options;

  const response = await fetch(shopifyConfig.endpoint, {
    method: 'POST',
    cache: 'no-store',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': shopifyConfig.storefrontToken,
    },
    body: JSON.stringify({
      query,
      variables,
    }),
  });

  if (!response.ok) {
    const text = await response.text();
    throw new Error(`Shopify request failed: ${response.status} ${response.statusText} - ${text}`);
  }

  const json = (await response.json()) as ShopifyGraphQLResponse<T>;

  if (json.errors && json.errors.length > 0) {
    const message = json.errors.map((e) => e.message).join(', ');
    throw new Error(`Shopify GraphQL error: ${message}`);
  }

  if (!json.data) {
    throw new Error('Shopify response did not contain data.');
  }

  return json.data;
}

